import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminProjectRequest from "../../../components/admin/project/AdminProjectRequest";

//어드민 프로젝트 추가 요청 페이지
const AdminProjectRequestPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //프로젝트 추가 요청 식별자가 없는 경우
    if (!id) {
        return <div>Invalid project request ID</div>
    }

    return (
        <AdminLayout>
            {/*프로젝트 추가 요청 상세 페이지 버튼*/}
            <AdminProjectRequest requestId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminProjectRequestPage;